// InspireCareerFestAlbum.js

import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Modal,
  Backdrop,
  IconButton,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";

// Local image imports
import Img1 from "./../../assets/images/InspireCarrerFest/Img1.jpg";
import img1 from "../../assets/images/InspireCarrerFest/1.jpg";
import img2 from "../../assets/images/InspireCarrerFest/2.jpg";
import img3 from "../../assets/images/InspireCarrerFest/3.jpg";
import img4 from "../../assets/images/InspireCarrerFest/4.jpg";
import img5 from "../../assets/images/InspireCarrerFest/5.jpg";
import img6 from "../../assets/images/InspireCarrerFest/6.jpg";
import img7 from "../../assets/images/InspireCarrerFest/7.jpg";
import img8 from "../../assets/images/InspireCarrerFest/8.jpg";
import img9 from "../../assets/images/InspireCarrerFest/9.jpg";
import img10 from "../../assets/images/InspireCarrerFest/10.jpg";
import img11 from "../../assets/images/InspireCarrerFest/11.jpg";
import img12 from "../../assets/images/InspireCarrerFest/12.jpg";
import img13 from "../../assets/images/InspireCarrerFest/13.jpg";
import img15 from "../../assets/images/InspireCarrerFest/15.jpg";
import img16 from "../../assets/images/InspireCarrerFest/20.jpg";
import img17 from "../../assets/images/InspireCarrerFest/17.jpg";
import img18 from "../../assets/images/InspireCarrerFest/18.jpg";
import img21 from "../../assets/images/InspireCarrerFest/21.jpg";
import img23 from "../../assets/images/InspireCarrerFest/23.jpg";

const imageUrls = [
  Img1,
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,

  img12,
  img13,
  img15,
  img16,
  img17,
  img18,
];

const InspireCareerFestAlbum = () => {
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  const handleOpen = (index) => {
    setCurrentIndex(index);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);
  const handleBack = () => navigate(-1);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    initialSlide: currentIndex,
  };

  return (
    <Container>
      <Box sx={{ backgroundColor: "#f9f9f9", p: 3, borderRadius: 2, mb: 5 }}>
        <IconButton onClick={handleBack} sx={{ mb: 3 }}>
          <ArrowBack fontSize="large" />
        </IconButton>
        <Typography textAlign="center" variant="h4" fontWeight="bold" mb={3}>
          🌟 Inspire CareerFest 2025 – Career Guidance Program 🌟
        </Typography>

        <Typography textAlign="justify" variant="body1">
          Alhamdulillah, TIET successfully organized the Career Guidance Program
          titled “Inspire CareerFest 2025” on 19-05-2025 (Sunday), from
          9.30AM–1.00PM at Masjid Usman Auditorium. This program was intended
          for students of Std 9th–12th (boys and girls) and those who appeared
          for board exams, covering careers in Science, Arts, Commerce, NEET,
          JEE, CUET, NDA, Law, IAS/KAS, and trending options in Technology,
          Artificial Intelligence, Aviation, and other professional programs.
          <br />
          <br />
          🎯 The aim was to motivate and prepare young minds in our community
          with a strong mindset to pursue careers and dreams that align with
          Islamic values and social responsibilities.
          <br />
          <br />
          🎤 The program featured experienced career coaches, educationists, and
          real-time professionals, giving students a practical understanding of
          career paths, entrance exams, scholarships, and roadmap guidance.
          <br />
          <br />
          🧠 Sessions were interactive and enlightening, covering aptitude
          insights, skill-building, and self-assessment tools to identify
          strengths.
          <br />
          <br />
          📸 Below are glimpses of our successful and engaging event. May Allah
          (SWT) accept our efforts and help our students in choosing the best
          careers in both Duniya and Aakhirah. Ameen!
        </Typography>
      </Box>

      <Grid container spacing={2} justifyContent="center">
        {imageUrls.map((src, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <img
              src={src}
              alt={`Event ${index + 1}`}
              onClick={() => handleOpen(index)}
              style={{
                width: "100%",
                height: "300px",
                objectFit: "cover",
                cursor: "pointer",
                borderRadius: "10px",
              }}
            />
          </Grid>
        ))}
      </Grid>

      <Modal
        open={open}
        onClose={handleClose}
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            width: "100vw",
            bgcolor: "rgba(0, 0, 0, 0.9)",
          }}
        >
          <Box sx={{ width: "90vw", height: "90vh" }}>
            <Slider {...settings}>
              {imageUrls.map((src, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "90vh",
                    width: "90vw",
                  }}
                >
                  <img
                    src={src}
                    alt={`Event ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Box>
              ))}
            </Slider>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default InspireCareerFestAlbum;
